import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faArrowLeft, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import './Page3.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Batsmans() {
  const navigate = useNavigate();
  const match_id = localStorage.getItem('match_id');

  const [matchdetails, setMatchdetails] = useState({
    host_team: '',
    visitor_team: '',
    overs: '',
    toss_winner: '',
    opted_to: ''
  });

  const [team, setTeam] = useState('');
  const [bat, setBat] = useState([]);
  const [striker, setStriker] = useState({ name: '', position: '' });
  const [non_striker, setNon_striker] = useState({ name: '', position: '' });
  const [bowler, setBowler] = useState({ name: '', position: '' });

  const [thisOver, setThisOver] = useState([]);
  const [currentOver, setCurrentOver] = useState(0);
  const [ballNumber, setBallNumber] = useState(1);
  const [newbatsmancoming, setNewbatsmancoming] = useState(false);

  const [strikerStats, setStrikerStats] = useState(null);
  const [nonStrikerStats, setNonStrikerStats] = useState(null);
  const [bowlerStats, setBowlerStats] = useState(null);
const [loading, setLoading] = useState(false);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  const [extras, setExtras] = useState({
    wide: false,
    no_ball: false,
    byes: false,
    leg_byes: false,
    wicket: false
  });

  const [totalRuns, setTotalRuns] = useState(0);
  const [wickets, setWickets] = useState(0);

  useEffect(() => {
    if (!match_id) return;

    fetch(`https://nammateam.onrender.com/match/${match_id}`)
      .then(res => res.json())
      .then(d => {
        setMatchdetails(d);
        const batting_team =
          d.toss_winner === d.host_team
            ? (d.opt_to === 'bat' ? d.host_team : d.visitor_team)
            : (d.opt_to === 'bat' ? d.visitor_team : d.host_team);
        setTeam(batting_team);
      });

    fetch(`https://nammateam.onrender.com/bowling/${match_id}`)
      .then(res => res.json())
      .then(data => {
        const activeBowler = data.find(b => b.status === 'active');
        if (activeBowler) {
          setBowler({ name: activeBowler.name, position: activeBowler.position });
        }
      });

    fetch(`https://nammateam.onrender.com/match/summary/${match_id}`)
      .then(res => res.json())
      .then(summary => {
        if (summary.success) {
          setTotalRuns(summary.total_runs);
          setWickets(summary.total_wickets);
        }
      });

    fetch(`https://nammateam.onrender.com/ball/last/${match_id}`)
      .then(res => res.json())
      .then(({ over, ball }) => {
        setCurrentOver(over);
        setBallNumber(ball);
      });

  }, [match_id]);

  useEffect(() => {
    if (!match_id) return;

    fetch(`https://nammateam.onrender.com/batting/${match_id}`)
      .then(res => res.json())
      .then(data => {
        setBat(data);
        const notOutPlayers = data.filter(p => p.status === "not out");

        if (newbatsmancoming && wickets > 0) {
          const whoGotOut = localStorage.getItem("whoGotOut");

          if (whoGotOut === "striker") {
            setStriker({ name: notOutPlayers[1]?.name, position: notOutPlayers[1]?.position });
            setNon_striker({ name: notOutPlayers[0]?.name, position: notOutPlayers[0]?.position });
          } else if (whoGotOut === "non-striker") {
            setStriker({ name: notOutPlayers[0]?.name, position: notOutPlayers[0]?.position });
            setNon_striker({ name: notOutPlayers[1]?.name, position: notOutPlayers[1]?.position });
          }
          setNewbatsmancoming(false);
        } else if (
          localStorage.getItem("matchset") === "true" &&
          wickets === 0 &&
          currentOver === 0 &&
          ballNumber === 1
        ) {
          setStriker({ name: notOutPlayers[0]?.name, position: notOutPlayers[0]?.position });
          setNon_striker({ name: notOutPlayers[1]?.name, position: notOutPlayers[1]?.position });
        } else {
          const sname = localStorage.getItem("sname");
          const sposition = localStorage.getItem("sposition");
          const nname = localStorage.getItem("nname");
          const nposition = localStorage.getItem("nposition");
          setStriker({ name: sname, position: sposition });
          setNon_striker({ name: nname, position: nposition });
        }
      });
  }, [newbatsmancoming, match_id, wickets, currentOver, ballNumber]);

  useEffect(() => {
    if (!match_id || currentOver == null) return;
    fetch(`https://nammateam.onrender.com/over/summary/${match_id}/${currentOver}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setThisOver(data.summary);
      });
  }, [match_id, currentOver]);

  useEffect(() => {
    fetchPlayerStats();
  }, [striker.name, non_striker.name, bowler.name]);

  const fetchPlayerStats = async () => {
    if (!striker.name || !non_striker.name || !bowler.name || !match_id) return;
    try {
      const res = await fetch(`https://nammateam.onrender.com/stats/get?match_id=${match_id}&striker=${striker.name}&non_striker=${non_striker.name}&bowler=${bowler.name}`);
      const data = await res.json();
      setStrikerStats(data.striker);
      setNonStrikerStats(data.non_striker);
      setBowlerStats(data.bowler);
    } catch (err) {
      console.error("Failed to fetch stats", err);
    }
  };

  const handleExtrasChange = (e) => {
    const { name, checked } = e.target;
    setExtras(prev => ({ ...prev, [name]: checked }));
  };

  // const updateThisOverUI = (val) => {
  //   setThisOver(prev => [...prev, val]);
  // };
const updateThisOverUI = async () => {
  if (!match_id || currentOver == null) return;

  try {
    const res = await fetch(
      `https://nammateam.onrender.com/over/summary/${match_id}/${currentOver}`
    );
    const data = await res.json();
    if (data.success) {
      setThisOver(data.summary);
    }
  } catch (err) {
    console.error("Error updating this over:", err);
  }
};

  const getBallClass = (val) => {
    if (val.startsWith("wd") || val.startsWith("nb") || val.startsWith("b") || val.startsWith("lb")) return "ball green";
    if (val === "W") return "ball red";
    if (val === "4" || val === "6") return "ball blue";
    return "ball";
  };

  const handleBallSubmit = async (runVal) => {

 if (loading) return; // prevent double clicks
  setLoading(true);

    if (currentOver >= parseInt(matchdetails.overs)) {
      alert("Overs completed! Match innings closed.");
       setLoading(false);
      return;
    }

    let runs = parseInt(runVal);
    let extraType = null;
    let extra_runs = 0;
    let legalDelivery = true;
    let ballFaced = true;

    if (extras.wide) {
      extraType = "wide";
      extra_runs = 1 + runs;
      runs = 0;
      legalDelivery = false;
      ballFaced = false;
    } else if (extras.byes || extras.leg_byes) {
      extraType = extras.byes ? "byes" : "leg_byes";
      extra_runs = runs;
      runs = 0;
      legalDelivery = true;
      ballFaced = true;
    } else if (extras.no_ball) {
      extraType = "no_ball";
      extra_runs = 1 + runs;
      runs = 0;
      legalDelivery = false;
      ballFaced = false;
    }

    const payload = {
      match_id,
      innings: 1,
      overs: currentOver,
      ball_number: ballNumber,
      batsman_name: striker.name,
      bowler_name: bowler.name,
      runs,
      extra_type: extraType,
      extra_runs,
      is_wicket: extras.wicket,
      dismissal_type: extras.wicket ? "unknown" : null,
      ball_faced: ballFaced,
      legal_delivery: legalDelivery
    };

    try {
      const res = await fetch('https://nammateam.onrender.com/ball/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();

      if (data.message === 'Ball recorded and stats updated') {
        let displayRun = runVal;
        if (extras.wide) displayRun = `wd${runVal !== "0" ? runVal : ""}`;
        else if (extras.no_ball) displayRun = `nb${runVal !== "0" ? `+${runVal}` : ""}`;
        else if (extras.byes) displayRun = `b${runVal}`;
        else if (extras.leg_byes) displayRun = `lb${runVal}`;
        else if (extras.wicket) displayRun = "W";

        // updateThisOverUI(displayRun);
await updateThisOverUI();

        await fetchPlayerStats();

        fetch(`https://nammateam.onrender.com/match/summary/${match_id}`)
          .then(res => res.json())
          .then(summary => {
            if (summary.success) {
              setTotalRuns(summary.total_runs);
              setWickets(summary.total_wickets);
            }
          });

        // Strike swap & over logic
        let isLastBallOfOver = false;
        let strikerAfterBall = striker;
        let nonStrikerAfterBall = non_striker;

        if (extras.wide ||  extras.no_ball) {
          if ((extra_runs - 1) % 2 === 1) {
            [strikerAfterBall, nonStrikerAfterBall] = [non_striker, striker];
          }
        } else if(extras.byes || extras.leg_byes )
        {
          const newBall = ballNumber + 1;
 if ((extra_runs ) % 2 === 1) {
            [strikerAfterBall, nonStrikerAfterBall] = [non_striker, striker];
          }
          setBallNumber(newBall)
        }
         else {
          const newBall = ballNumber + 1;
          if (newBall <= 6 && runs % 2 === 1) [strikerAfterBall, nonStrikerAfterBall] = [non_striker, striker];
          if (newBall > 6) {
            isLastBallOfOver = true;
            setCurrentOver(prev => prev + 1);
            setBallNumber(1);
            if (runs % 2 === 0) [strikerAfterBall, nonStrikerAfterBall] = [non_striker, striker];
          } else {
            if (legalDelivery) setBallNumber(newBall);
          }
        }

        setStriker(strikerAfterBall);
        setNon_striker(nonStrikerAfterBall);

        localStorage.setItem("sname", strikerAfterBall.name);
        localStorage.setItem("sposition", strikerAfterBall.position);
        localStorage.setItem("nname", nonStrikerAfterBall.name);
        localStorage.setItem("nposition", nonStrikerAfterBall.position);
        localStorage.setItem("matchset", "false");

        setExtras({ wide: false, no_ball: false, byes: false, leg_byes: false, wicket: false });

        if (extras.wicket) {
          setNewbatsmancoming(true);
          const overBall = `${currentOver}.${ballNumber}`;
  localStorage.setItem("out_over", overBall);
  localStorage.setItem("out_bowler", bowler.name);
          if (isLastBallOfOver) {
            localStorage.setItem("lastball", "yes");
            navigate('/newbatsman', { state: { striker: non_striker, nonstriker: striker, nextpage: '/newbowler' } });
          } else {
            navigate('/newbatsman', { state: { striker, nonstriker: non_striker, nextpage: null } });
          }
        } else if (isLastBallOfOver) {
          navigate('/newbowler');
        }
      }
    } catch (err) {
      console.error("Ball submit error", err);
    } finally {
    setLoading(false); // ✅ always re-enable buttons
  }
  };

  // 🔹 FULL Undo logic
  const handleUndo = async () => {
    try {
      const res = await fetch(`https://nammateam.onrender.com/ball/undo/${match_id}`, { method: 'DELETE' });
      const data = await res.json();

      if (data.message.includes("successfully")) {
        // 1️⃣ Remove last ball from UI
        setThisOver(prev => prev.slice(0, -1));

        // 2️⃣ Fetch latest stats
        await fetchPlayerStats();

        // 3️⃣ Update total runs and wickets
        const summaryRes = await fetch(`https://nammateam.onrender.com/match/summary/${match_id}`);
        const summaryData = await summaryRes.json();
        if (summaryData.success) {
          setTotalRuns(summaryData.total_runs);
          setWickets(summaryData.total_wickets);
        }

        // 4️⃣ Update over and ball number correctly
        const lastBallRes = await fetch(`https://nammateam.onrender.com/ball/last/${match_id}`);
        const lastBall = await lastBallRes.json();
        if (lastBall) {
          setCurrentOver(lastBall.over);
          setBallNumber(lastBall.ball + 1);
        } else {
          setCurrentOver(0);
          setBallNumber(1);
        }

        // 5️⃣ Handle strike swap based on last ball runs (basic: just revert)
        const temp = striker;
        setStriker(non_striker);
        setNon_striker(temp);

        // 6️⃣ Clear extras
        setExtras({ wide: false, no_ball: false, byes: false, leg_byes: false, wicket: false });

        alert("Last ball undone!");
      } else {
        alert("Nothing to undo");
      }
    } catch (err) {
      console.error("Undo error", err);
      alert("Failed to undo last ball");
    }
  };

  const handleSwapBatsman = () => {
    setStriker(prev => {
      const temp = non_striker;
      setNon_striker(prev);
      return temp;
    });

    localStorage.setItem("sname", non_striker.name);
    localStorage.setItem("sposition", non_striker.position);
    localStorage.setItem("nname", striker.name);
    localStorage.setItem("nposition", striker.position);
  };

  const totalBalls = (currentOver * 6) + (ballNumber - 1);
  const crr = totalBalls > 0 ? (totalRuns / (totalBalls / 6)).toFixed(2) : '0.00';

  return (
    <div className='batsmans-container'>
      <div className='score-header'>
        <p className='team-names' >
          {/* <FontAwesomeIcon icon={faArrowLeft} /> */}
          {matchdetails.host_team} v/s {matchdetails.visitor_team}</p>
        <div className='score-icons'>

          <p>{currentOver}.{ballNumber - 1}</p>
          <FontAwesomeIcon
            icon={faBars}
            className='hamburger'
            onClick={() => setSidebarOpen(true)}
          />
        </div>
      </div>

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className='close-btn' onClick={toggleSidebar}><FontAwesomeIcon icon={faTimes} /> Close</button>
        <ul>
          <li onClick={() => navigate('/live')}>Live</li>
          <li onClick={() => navigate('/summary')}>Summary</li>
          <li onClick={() => navigate('/full')}>Full Scorecard</li>
          <li onClick={() => navigate('/batstats')}>Batting Scorecard</li>
          <li onClick={() => navigate('/bowlstats')}>Bowling Scorecard</li>
          <li onClick={() => navigate('/overs')}>Overs</li>
          <li onClick={() => navigate('/chart')}>Chart</li>
        </ul>
      </div>

      <div className='inning-summary'>
        <div>
          <p className='team-inn' >{team}, 1st inning</p>
          <h2 className='high-high' >{totalRuns} - {wickets} <span className='high2' >({currentOver}.{ballNumber - 1})</span></h2>
        </div>
        <div className='crr'>
          <p>CRR</p>
          <h3>{crr}</h3>
        </div>
      </div>

      <div className='scorecard'>
        <div className='scorecard-header'>
          <p className='player-name' >Batsman</p><p>R</p><p>B</p><p>4s</p><p>6s</p><p>SR</p>
        </div>

        <div className='scorecard-row'>
          <p className='player-name' >{striker.name} *</p>
          <p>{strikerStats?.runs || 0}</p>
          <p>{strikerStats?.balls_faced || 0}</p>
          <p>{strikerStats?.fours || 0}</p>
          <p>{strikerStats?.sixes || 0}</p>
          <p>{(strikerStats?.strike_rate || 0).toFixed(2)}</p>
        </div>

        <div className='scorecard-row'>
          <p className='player-name' >{non_striker.name}</p>
          <p>{nonStrikerStats?.runs || 0}</p>
          <p>{nonStrikerStats?.balls_faced || 0}</p>
          <p>{nonStrikerStats?.fours || 0}</p>
          <p>{nonStrikerStats?.sixes || 0}</p>
          <p>{(nonStrikerStats?.strike_rate || 0).toFixed(2)}</p>
        </div>

        <div className='scorecard-header'>
          <p className='player-name' >Bowler</p><p>O</p><p>M</p><p>R</p><p>W</p><p>ER</p>
        </div>

        <div className='scorecard-row'>
          <p className='player-name' >{bowler.name}</p>
          <p>{Math.floor((bowlerStats?.balls_bowled || 0) / 6)}.{(bowlerStats?.balls_bowled || 0) % 6}</p>
         <p>{bowlerStats?.maidens || 0}</p>
          <p>{bowlerStats?.runs_given || 0}</p>
          <p>{bowlerStats?.wickets || 0}</p>
          <p>{(bowlerStats?.economy || 0).toFixed(2)}</p>
        </div>
      </div>

      <div className='this-over'>
        <p>This over:
          {thisOver.map((item, idx) => (
            <span key={idx} className={getBallClass(item)}>{item}</span>
          ))}
        </p>
      </div>

      <div className='extras-section'>
        

          <div className='extras-checkboxes'>
            <label>
              <input
                type='checkbox'
                name="wide"
                checked={extras.wide}
                onChange={handleExtrasChange}
              /> Wide
            </label>
            <label>
              <input
                type='checkbox'
                name="no_ball"
                checked={extras.no_ball}
                onChange={handleExtrasChange}
              /> No Ball
            </label>
            <label>
              <input
                type='checkbox'
                name="byes"
                checked={extras.byes}
                onChange={handleExtrasChange}
              /> Byes
            </label>
            <label>
              <input
                type='checkbox'
                name="leg_byes"
                checked={extras.leg_byes}
                onChange={handleExtrasChange}
              /> Leg Byes
            </label>
            <label>
              <input
                type='checkbox'
                name="wicket"
                checked={extras.wicket}
                onChange={handleExtrasChange}
              /> Wicket
            </label>
            <button className='btn-green' onClick={handleSwapBatsman}>Swap Batsman</button>
          <button className='btn-green' onClick={handleUndo}>Undo</button>
          </div>

        
       <div className='extras-actions'>
    
        </div> 
        
      </div>

      {/* <div className='nummatrix'>
        {["0", "1", "2", "3", "4", "5", "6"].map(num => (
          <button className='numbtn' key={num} onClick={() => handleBallSubmit(num)}>{num}</button>
        ))}
      </div> */}
      <div className='nummatrix'>
  {["0", "1", "2", "3", "4", "5", "6"].map(num => (
    <button
      className='numbtn'
      key={num}
      onClick={() => handleBallSubmit(num)}
      disabled={loading}  // ✅ disable while API is running
    >
      {loading ? "..." : num}
    </button>
  ))}
</div>

    </div>
  );
}

export default Batsmans;
